let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bqaSW")).then(() => parcelRequire('jysme'));